let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("34Ma8")).then(() => parcelRequire('cp7FA'));